import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'

import {
  CREATED,
  OptimizationProcessStatus,
  RUNNING,
} from '../../../types/optimizationProcesses'
import { useAbortOptimizationProcess } from './useAbortOptimizationProcess'

export const AbortButton = ({
  optimizationProcessId,
  status,
}: {
  optimizationProcessId: number
  status: OptimizationProcessStatus
}) => {
  const { mutate: abort, isLoading } = useAbortOptimizationProcess()
  return status === CREATED || status === RUNNING ? (
    <Button
      icon={<FontAwesomeIcon icon={faXmark} />}
      onClick={(e) => {
        e.stopPropagation()
        abort(optimizationProcessId)
      }}
      label={status === RUNNING ? 'Stop' : 'Remove'}
      loading={isLoading}
      disabled={isLoading}
      buttonType="button"
      type="destroy"
      size="xs"
    />
  ) : null
}
